export function installVue2InstanceCompat(app) {
  app.config.globalProperties.$set = (target, key, value) => {
    target[key] = value
    return value
  }

  app.config.globalProperties.$delete = (target, key) => {
    delete target[key]
  }
}
